<template>
  <DBox
    :id="'cmp-catalog-projects-sidewindow-projects_costs'"
    :addButton="false"
    :addLink="false"
  >
    <NTable
      id="catalog-projects-sidewindow-projects_costs-list"
      class="h1 dbox1"
      :config="tableConfig"
      :headers="headers"
      :items="list"
      :showNoItems="true"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('costgroups')">
            <span
              @click.stop="e => onSelectProject(item)"
              class="txtov ut-link ut-text-accent5"
              :title="item['description']"
            >
              {{ item["description"] }}
            </span>
          </td>
          <td v-bind="tdcon('type')">
            <Dropdown2
              class="dbox1"
              :showLabel="false"
              deselect
              :options="selectedProjectDetails.marketing_typesTV"
              :selected="
                selectedProjectDetails.marketing_typesTV.find(
                  e => e.value == item.marketing_type_id
                )
              "
              v-on:selectedChange="
                e => onDropdownChange('marketing_type_id', e, item)
              "
              :bb="'0px'"
            />
          </td>
          <td v-bind="tdcon('date')">
            <span class="txtov" :title="item['date']">
              {{ item["date"] }}
            </span>
          </td>
          <td v-bind="tdcon('item')">
            <span class="txtov" :title="item['item']">
              {{ item["item"] }}
            </span>
          </td>
          <td v-bind="tdcon('description')">
            <span class="txtov" :title="item['description']">
              {{ item["description"] }}
            </span>
          </td>
          <!-- <td v-bind="tdcon('amount')">
            <div class="ut-flex ut-fw-20">
              <div class="ut-mx-auto txtov ut-link ut-text-accent5">
                {{ item["amount"] }}
              </div>
              <img
                v-if="item['partner_email']"
                src="static/icons/cloud.svg"
                class="dt-icon v5 s1"
                @click.stop="(e) => onMailClick(item['partner_email'])"
                alt="Amount"
                title="Amount"
              />
            </div>
          </td> -->
          <td
            v-bind="tdcon('amount')"
            :title="item['file_id'] ? '' : $t('upload_documents')"
          >
            <div class="ut-flex">
              <div class="dt-icon-container" style="margin-left: -5px">
                <img
                  @click.stop="e => onUploadFile(item)"
                  :src="
                    item['file_id']
                      ? 'static/icons/cloud-fill.svg'
                      : 'static/icons/cloud.svg'
                  "
                  class="dt-icon v5 s2"
                />
              </div>
              <span>
                <!-- {{ cost_income_groupText(item) }} -->
                {{ item["amount"] }}
              </span>
            </div>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";

export default {
  components: {
    DBox,
    NTable
  },
  props: ["selectedProjectDetails"],
  data: function() {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        rowHeight: 32,
        fullHeight: true
      })
    };
  },
  computed: {
    list: function() {
      return this.selectedProjectDetails?.costs || [];
    },
    headers: function() {
      return [
        createTableHeader("costgroups"),
        createTableHeader("type"),
        createTableHeader("date"),
        createTableHeader("item"),
        createTableHeader("description"),
        createTableHeader("amount")
      ];
    }
  },
  methods: {
    onTextFieldValueChange: function({ name, value }, item) {
      console.log("payload ", { name, value, item });
      //   this.$emit("changed", { name, value, item });
    },

    onDropdownChange: function(name, e, item) {
      // console.log("payload ", { name, value: e.value, item });
      this.$emit("changed", { name, value: e.value ? e.value : "", item });
    },

    onSelectProject: function(selectedCatalog) {
      //   this.$emit("selected", selectedCatalog.product_id);
    },
    onUploadFile(item) {
      console.log("Upload ", item);
      this.$emit("uploaded", item);
    }
  }
};
</script>

<style lang="scss">
.cmp-catalog-projects-sidewindow-projects_costs {
  // .dropdown-2 {
  //   .txtov {
  //     height: 32px;
  //   }
  // }
  // .dropdown {
  //   max-width: 250px;
  // }

  // .dt-ntable {
  //   margin-top: 10px;
  // }
}
</style>
